import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "edit",
  "use": "edit-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"icon icon-tabler icon-tabler-edit\" viewBox=\"0 0 24 24\" id=\"edit\"><path stroke=\"none\" d=\"M0 0h24v24H0z\" /><path d=\"M9 7H6a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-3\" /><path d=\"M9 15h3l8.5-8.5a1.5 1.5 0 0 0-3-3L9 12zM16 5l3 3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol